import React from 'react';
import { FaExclamationTriangle, FaTimesCircle, FaCheck } from 'react-icons/fa';

export const DocumentoHeader = ({ children, type = 'success', ...rest }) => {
    return (
        <div className={'alert alert--outline fade show alert-' + type} role="alert">
            <div className={'alert-icon alert-' + type}>
                {type === 'success' && <FaCheck className="f-icon" size="20" />}
                {type === 'warning' && <FaExclamationTriangle className="f-icon" size="20" />}
                {type === 'danger' && <FaTimesCircle className="f-icon" size="20" />}
            </div>

            <div className="card-title alert-message">
                <div dangerouslySetInnerHTML={{ __html: children }} />
            </div>
            <div className="indicator "></div>
        </div>
    );
};
